import { Button, Grid, Paper, Typography, Box } from "@mui/material";
import EventIcon from '@mui/icons-material/Event';
import { gridSizeMdLg8 } from "@/shared";
import CustomAutoCompleteGroupBy from "@/shared/components/ui/CustomAutoCompleteGroupBy";
import { useState } from "react";
import { SampleDatePicker } from "@/shared/components/ui";
import { useAgendaVisitaDiaria } from "../../hook/useAgendaVisitaDiaria";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { MaterialReactTable } from "material-react-table";
import useTableColumnAgendaVisita from "../../hook/useTableColumnAgendaVisita";

type AgendaVisitaDiariaViewProps = {
  title?: string
}

export default function AgendaVisitaDiariaView({ title }: AgendaVisitaDiariaViewProps) {
  const [tecnico, setTecnico] = useState<any>(null)
  const [provincia, setProvincia] = useState<any>(null)
  const [ciudad, setCiudad] = useState<any>(null)
  const {
    form,
    control,
    errors
  } = useAgendaVisitaDiaria()

  const {
    columnsPautas
  } = useTableColumnAgendaVisita()

  const dataPautas = [
    {
      nombre: "Instalación",
      descripcion:
        "Lineamientos y requisitos para la instalación inicial del servicio al cliente."
    },
    {
      nombre: "Traslado",
      descripcion:
        "Procedimiento para trasladar el servicio a una nueva ubicación solicitada por el cliente."
    },
    {
      nombre: "Retiro",
      descripcion:
        "Normas y pasos para el retiro definitivo o baja del servicio, incluyendo devolución de equipos."
    },
    {
      nombre: "Migración",
      descripcion:
        "Reglas para el cambio de plan, tecnología o infraestructura sin afectar la continuidad del servicio."
    }
  ];


  return (
    <Paper elevation={3} sx={{ mb: 2, borderRadius: 2 }}>
      <Typography variant="h4" sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 2 }}>
        <EventIcon fontSize="large" />
        {title}
      </Typography>

      <Grid container spacing={3} sx={{ p: 2 }}>
        {/* Left column: Provincia, Ciudad, Técnico stacked */}
        <Grid item xs={12} md={4}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <CustomAutoCompleteGroupBy
              label="Provincia"
              options={[]}
              value={provincia}
              onChange={(value) => setProvincia(value)}
              getOptionLabel={(op) => op.provincia}
              isOptionEqualToValue={(op, val) => op?.provincia === val?.provincia}
            />

            <CustomAutoCompleteGroupBy
              label="Ciudad"
              options={[]}
              value={ciudad}
              onChange={(value) => setCiudad(value)}
              getOptionLabel={(op) => op.ciudad}
              isOptionEqualToValue={(op, val) => op?.ciudad === val?.ciudad}
            />

            <CustomAutoCompleteGroupBy
              label="Técnico"
              options={[]}
              value={tecnico}
              onChange={(value) => setTecnico(value)}
              getOptionLabel={(op) => op.tecnico}
              isOptionEqualToValue={(op, val) => op?.tecnico === val?.tecnico}
            />
          </Box>
        </Grid>

        {/* Right column: Fecha+Botón arriba, Tabla debajo */}
        <Grid item xs={12} md={8}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
            <Box sx={{ flex: 1 }}>
              <SampleDatePicker
                label="Fecha"
                name="fecha"
                control={control}
                defaultValue={form.getValues("fecha") || ''}
                error={errors.fecha as any}
                helperText={errors.fecha?.message as any}
                size={gridSizeMdLg8}
              />
            </Box>

            <Button
              variant="contained"
              color="primary"
              sx={{ height: 'fit-content', whiteSpace: 'nowrap' }}
              endIcon={<ManageSearchIcon />}
            >
              Consultar Agenda
            </Button>
          </Box>

          <Box sx={{ mb: 1 }}>
            <Typography variant="h6">Pautas</Typography>
            <Typography variant="caption" color="text.secondary">Instalación · Traslado · Retiro · Migración</Typography>
          </Box>

          <MaterialReactTable
            columns={columnsPautas}
            data={dataPautas}
            initialState={{ density: "comfortable" }}
            enableBottomToolbar={false}
            enableColumnActions={false}
            enableSorting={false}
            enableGlobalFilter={false}
            enableTopToolbar={false}
            enableDensityToggle={false}
            enableFullScreenToggle={false}
            enableStickyHeader
            muiTableBodyCellProps={{
              sx: {
                py: 1,
                px: 1.5,
                fontSize: "0.9rem",
                borderBottom: "none"
              }
            }}
            muiTableHeadCellProps={{
              sx: {
                py: 1,
                px: 1.5,
                fontSize: "0.9rem",
                fontWeight: 700,
                borderBottom: '1px solid rgba(0,0,0,0.12)'
              }
            }}
            muiTablePaperProps={{ sx: { borderRadius: 2, boxShadow: 1 } }}
            muiTableContainerProps={{
              sx: {
                maxHeight: 300,
                borderRadius: 2
              }
            }}
            muiTableBodyRowProps={({ row }) => ({
              sx: {
                backgroundColor: row.index % 2 === 0 ? 'background.paper' : 'action.hover',
                transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 }
              }
            })}
          />
        </Grid>

      </Grid>
    </Paper>
  )
}